import {Alert} from 'platform/components';
import {Show, Text, VStack} from 'platform/foundation';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';

import {ExtractDeliveryNoteDocumentResult} from '@prompt-bridge/shared/validations';

interface StructuredInvoiceNoticeProps {
  source: ExtractDeliveryNoteDocumentResult['structuredSource'];
  invoiceNumber: string | null | undefined;
}

export function StructuredInvoiceNotice(props: StructuredInvoiceNoticeProps) {
  if (isNil(props.source)) {
    return null;
  }

  return (
    <VStack spacing={2}>
      <Alert
        type="inline"
        variant="warning"
        title={`${i18n.t('entity.businessCase.labels.invoice')}: ${props.invoiceNumber ?? ''}`}
        message={i18n.t('entity.documentExtraction.labels.itemsAreNotAvailableMessage')}
      />
      <Text size="small">
        {i18n.t('entity.businessInfo.labels.institutions.supplier')}: {props.source.supplierName} (
        {props.source.supplierTaxId})
      </Text>
      <Text size="small">
        {i18n.t('entity.customer.labels.customer')}: {props.source.customerName} (
        {props.source.customerTaxId})
      </Text>
      <Show when={props.source.vatExemptionCode}>
        <Text size="small">
          {i18n.t('entity.accounting.labels.vat')}: {props.source.vatExemptionCode}
        </Text>
      </Show>
    </VStack>
  );
}
